import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';

import './Login.css';

import { sendAsyncRequest, loadAuthoritiesOrLogout } from '../../services/AsyncRequestService';
import {
  isAuthenticated,
  cognitoLoginSuccess,
} from '../../services/AuthService';

import logo from "../../assets/images/RM Logo=Reversed.png";

import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
  const [redirectToForceChangePassword, setRedirectToForceChangePassword] = useState(false);
  const [cognitoUserSession, setCognitoUserSession] = useState(null);

  useEffect(() => {
    try {
      const flash = sessionStorage.getItem('loginErrorFlash');
      if (flash) {
        setError(flash);
        sessionStorage.removeItem('loginErrorFlash');
      }
    } catch (e) {
      // ignore storage failures
    }
  }, []);

  useEffect(() => {
    if (redirectToForceChangePassword) {
      console.log(redirectToForceChangePassword)
      navigate('/force-change-password', {
        state: { session: cognitoUserSession, email: email }
      });
    }
  }, [redirectToForceChangePassword, cognitoUserSession, email, navigate]);

  const handleChange = e => {
    const { name, value } = e.target;
    setError("");
    if (name === 'email') {
        setEmail(value);
    } else {
        setPassword(value);
    }
  }

  const handleLogin = (e) => {
    e.preventDefault();
    let url = "/auth/login";
    let method = "POST";
    let data = { email: email, password: password };
    sendAsyncRequest(url, method, data, onLoginSuccess, onLoginFailure);
  }

 const onLoginSuccess = (response) => {
    let data = response.data;
    if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
      setCognitoUserSession(data.session);
      setRedirectToForceChangePassword(true);
    } else {
      let userObjToSave = {
        uuid: data.uuid,
        name: data.name,
        authorities: data.authorities,
        email: data.email,
        tableAttributes: data.tableAttributes
      };
      cognitoLoginSuccess(userObjToSave,
        data.commitVersionId,
        data.currentReleaseNumber,
        data.deviceKey,
        data.currentTimeMillis,
        data.idTokenDurationSecs,
        data.csrfToken
      );
      loadAuthoritiesOrLogout(() => setRedirectToReferrer(true));
    }
  }

  const onLoginFailure = (error) => {
    setError("Incorrect email or password");
  }

  const { from } = location.state || { from: { pathname: '/' } };

  if (isAuthenticated() === true) {
    return <Navigate to="/" replace />;
  }

  if (redirectToReferrer === true) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="login-container">
      <div className="login-page">
              <Card className="login-card">
                <Card.Body>
                  <div className="logo-large">
                    <img src={logo} alt="Imagine RazorMetrics Logo" style={{ maxWidth: '200px' }} />
                  </div>
                  <h3 className="login-title">Login to RX Assist</h3>
                  {error && <Alert variant="danger">{error}</Alert>}
                  <Form onSubmit={handleLogin}>
                    <Form.Group className="form-group">
                      <div className="input-group">
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                        <Form.Control
                          type="email"
                          name="email"
                          value={email}
                          placeholder="Enter email"
                          onChange={handleChange}
                          className="form-control-with-icon"
                          required
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <div className="input-group">
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faLock} />
                        </span>
                        <Form.Control
                          type="password"
                          name="password"
                          value={password}
                          placeholder="Enter password"
                          onChange={handleChange}
                          className="form-control-with-icon"
                          required
                        />
                      </div>
                    </Form.Group>
                    <div className="text-right" style={{ marginBottom: '20px' }}>
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </div>
                    <Button type="submit" variant="primary" className="login-button">
                      Login
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
      </div>
    </div>
  );

}

export default Login;
